import dayjs from 'dayjs'

export type DurationEntity = {
  start_at: string
  finish_at: string
}

export const clusterOverlappingDurations = (data: DurationEntity[]) => {
  const fidnOverlappingDurations = (index: number) => {
    const stack = [index]
    const cluster: number[] = []

    while (stack.length > 0) {
      const currentIndex = stack.pop()
      if (currentIndex !== undefined && !cluster.includes(currentIndex)) {
        cluster.push(currentIndex)

        data.forEach((otherAppointment, otherIndex) => {
          if (
            currentIndex !== otherIndex &&
            !cluster.includes(otherIndex) &&
            dayjs.utc(otherAppointment.start_at) < dayjs.utc(data[currentIndex].finish_at) &&
            dayjs.utc(otherAppointment.finish_at) > dayjs.utc(data[currentIndex].start_at)
          ) {
            stack.push(otherIndex)
          }
        })
      }
    }

    return cluster
  }

  const clusters: number[][] = []

  data.forEach((_, index) => {
    const cluster = fidnOverlappingDurations(index)
    clusters.push(cluster)
  })

  return clusters
}
